module.exports = __webpack_public_path__ + "static/media/YF76_02.5b507b67.jpg";